<p-toast></p-toast>
<p-card>
  <div class="flex flex-col items-center gap-4 justify-between h-[60vh] w-[80vw]
           sm:h-[70vh] sm:w-[25vw] p-1 lg:p-4">
    <img alt="OCOP" class="max-w-full h-auto" height="96" ngSrc="./assets/images/ocop_logo.png" priority width="294"/>
    <div class="w-full space-y-2">
      <label class="block text-xs lg:text-sm text-gray-700" for="tokenInput">Digite seu e-mail</label>
      <input [formControl]="emailCtrl" class="w-full p-2 border rounded" id="emailInput" maxlength="255"
        name="email" placeholder="Digite..."
        type="email"
        (keydown.enter)="sendEmailForToken()"/>
      </div>
      <button (click)="sendEmailForToken()" [disabled]="loading"
        class="button-govbr button-govbr--gray w-full"
        >
        @if (!loading) {
          <app-icon-enviar-token class="mr-2"></app-icon-enviar-token>
          Enviar token
        }
        @if (loading) {
          <i class="pi pi-spin pi-spinner mr-2"></i>
          Enviando token
        }
      </button>
    </div>

  </p-card>
